import { configureStore } from "@reduxjs/toolkit";
import { persistStore } from "redux-persist";
import { rootReducer } from "./rootReducer";

// Configure the store
export const store = configureStore({
    reducer: rootReducer,
    middleware: (getDefaultMiddleware) =>
        getDefaultMiddleware({ serializableCheck: false })
            // .concat(geolocationMiddleware)
    // .concat(syncInspectionMiddleware)
    // .concat(serviceWorkerMiddleware),
});


// Configure the persistor
export const persistor = persistStore(store);


// Export utility types
export type AppDispatch = typeof store.dispatch;
export default store;
